import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      number: '1',
      title: 'Download & Sign Up',
      description: 'Get the app from App Store or Google Play and create your account'
    },
    {
      number: '2',
      title: 'Book a Service',
      description: 'Choose your preferred service and schedule a time that works for you'
    },
    {
      number: '3',
      title: 'We Come to You',
      description: 'Our professional team arrives at your location fully equipped'
    },
    {
      number: '4',
      title: 'Enjoy the Shine',
      description: 'Sit back and relax while we make your car sparkle'
    }
  ];

  return (
    <section id="how-it-works" className="how-it-works section">
      <div className="container">
        <div className="section-header text-center">
          <h2>How It Works</h2>
          <p>Getting your car cleaned has never been easier</p>
        </div>
        <div className="steps">
          {steps.map((step, index) => (
            <div key={index} className="step">
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;